module.exports = __webpack_public_path__ + "media/images/arrows/twisted/orange-left-eac33f508cbc5cda0f257180cc9fd7e0.svg";